import { img1, img2, img3, img4, img5, img6, img7, img8, img9, vid1, vid2, vid3, vid4, vid5 } from '../../assets';

export const slidesData = [
{
    url: img9, 
    title: 'GESTE: Sign Language Translator',
    githubUrl: 'https://gw-cs-sd-24-25.github.io/sd-asl/',
    description: 'Award-winning AI prototype using Meta Aria Glasses to translate German Sign Language into English. Designed the core NLP pipeline featuring a custom 6-layer sequence-to-sequence Transformer and Meta’s NLLB-200 model optimized for NVIDIA Jetson edge deployment. Winner of the 2025 Derril C. Rohlfs Award.',
    languages: ['Python', 'PyTorch', 'Transformers', 'NLLB-200', 'OpenCV', 'NVIDIA Jetson'],
    webButton: { url: 'https://engineering.gwu.edu/geste-sign-language-translator', label: 'View GWU Project Page', type: 'success' },
  },
  {
    url: img1,
    title: 'Portfolio',
    description: 'My Personal Portfolio',
    githubUrl: 'https://github.com/MatiasLiuS/MLSPortofolio',
    languages: ['HTML', 'Tailwind CSS', 'JavaScript', 'React.JS'],
    webButton: { url: 'https://www.matiasls.com/', label: 'Visit Portfolio', type: 'success' },
  },
  {
    url: img2,
    title: 'The Neuroscience Notebook',
    description: 'This podcast that was made as a special project by honors students at the George Washington University...',
    githubUrl: 'https://github.com/MatiasLiuS/NeuroscienceNotebook.github.io',
    languages: ['HTML', 'CSS', 'JavaScript'],
    videoUrl: vid1,
    webButton: { url: vid1, label: 'View Demo!', type: 'success' },
  },
  {
    url: img3,
    title: 'PUMP: Workout Manager Mobile App',
    description: 'Led the development for a Workout manager mobile app...',
    githubUrl: 'https://github.com/MatiasLiuS/PUMP-WorkoutManagerApp',
    languages: ['Android Studio', 'Kotlin', 'XML', 'RESTAPI', 'Firebase'],
    webButton: { url: 'https://docs.google.com/document/d/19MD85hPAgJOyAblBiPVllx9KAlpENq3u/edit', label: 'View Project Report!', type: 'success' },
  },
  {
    url: img4,
    title: 'ARGS - University Database',
    description: 'Team project of 3. We developed an Application Registration and Advising System...',
    githubUrl: 'https://github.com/MatiasLiuS/ARGS-SIP-University-Portal',
    languages: ['Python', 'MySQL', 'CSS', 'HTML'],
    webButton: { label: 'Live demo coming soon!', type: 'disabled' },
  },
  {
    url: img5,
    title: 'Slack Simulator',
    description: 'Created a Chat Room simulator that connects to a port with a valid IP address...',
    githubUrl: 'https://github.com/MatiasLiuS/GWackChatSimulator',
    languages: ['Java', 'JavaSwing'],
    videoUrl: vid3,
    webButton: { url: vid3, label: 'Watch a live demo!', type: 'success' },
  },
  {
    url: img6,
    title: 'Shopping Cart',
    description: 'Built with Python, CSS, HTML, and sqlite3...',
    githubUrl: 'https://github.com/MatiasLiuS/ShoppingCart',
    languages: ['Python', 'CSS', 'HTML', 'sqlite3'],
    videoUrl: vid2,
    webButton: { url: vid2, label: 'Watch a live demo!', type: 'success' },
  },
  {
    url: img7,
    title: 'SolAR',
    description: 'Welcome to the SolAR app! This app allows you to explore the solar system in augmented reality...',
    githubUrl: 'https://github.com/MatiasLiuS/solAR',
    languages: ['Unity', 'iOS', 'Augmented Reality'],
    videoUrl: vid4,
    webButton: { url: vid4, label: 'Watch the Trailer!', type: 'success' },
  },
  {
    url: img8,
    title: 'DinoDrive',
    description: 'Dino Drive presents an enthralling virtual reality experience... DinoDrive won the GWU 2024 Festival of Animation award for best Virtual Reality Experience',
    githubUrl: 'https://github.com/MatiasLiuS/DinoDrive',
    languages: ['Unity', 'Meta Quest 2', 'Virtual Reality'],
    videoUrl: vid5,
    webButton: { url: vid5, label: 'Watch the Trailer!', type: 'success' },
  },
];